import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./ShopProfile.css";
import Cart from "../cart/Cart";
import ShopCard from "../component/ShopCard";
import "../component/css/ShopCard.css";
import FruitShopCard from "../component/FruitShopCard";

const ShopProfile = ({
  addToCart,
  userEmail,
  userPhoneNumber,
  onCartUpdate,
  cartData,
}) => {
  const location = useLocation();
  const { shopId, searchedVegEng, searchedVegHin } = location.state || {};
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [shopDetails, setShopDetails] = useState(null);
  const [isShopClosed, setIsShopClosed] = useState(false);

  const [vegetables, setVegetables] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(false);

  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [selectedPrice, setSelectedPrice] = useState({});

  // NEW: Toast popup state
  const [showToast, setShowToast] = useState(false);

  // Fetch Shop Details
  useEffect(() => {
    if (shopId) {
      setLoading(true);
      fetch(
        `https://yaasaai.com/myphpapi/shop-details.php?shopId=${encodeURIComponent(
          shopId
        )}`
      )
        .then((response) => {
          if (!response.ok) throw new Error("Failed to fetch shop details.");
          return response.json();
        })
        .then((data) => {
          setShopDetails(data);
          console.log("Video filename:", data.video_filename);
          if (data.shop_quantity === "closed") {
            setIsShopClosed(true);
            console.log(data.shop_quantity);
          }
        })

        .catch((err) => setError(err.message))
        .finally(() => setLoading(false));
    }
  }, [shopId]);

  //tracking script
  window.gtag("event", "Shop_profile_visitem ", {
    screen_name: "shop screen visited",
    phone: userEmail,
    shopkiid: shopId,
  });

  // Fetch Vegetables
  useEffect(() => {
    if (shopId && !isShopClosed) {
      setLoading(true);
      fetch(
        `https://yaasaai.com/myphpapi/shop-all-vegetables.php?shopId=${encodeURIComponent(
          shopId
        )}`
      )
        .then((response) => {
          if (!response.ok) throw new Error("Failed to fetch vegetables.");
          return response.json();
        })
        .then((data) => {
          if (Array.isArray(data)) {
            setVegetables(data);
          } else {
            setVegetables([]);
          }
        })
        .catch((err) => {
          setError(err.message);
          setVegetables([]);
        })
        .finally(() => setLoading(false));
    }
  }, [shopId, isShopClosed]);

  const handleQuantityChange = (event, vegId, rates) => {
    const selectedLabel = event.target.value;
    const selectedRate = rates.find((rate) => rate.label === selectedLabel);

    //track event script
    if (typeof window.gtag === "function") {
      window.gtag("event", "quantity_selected", {
        veg_id: vegId,
        phone: userEmail,
        quantity_label: selectedLabel,
        price: selectedRate?.value ?? "unknown",
      });
    }

    setSelectedQuantity((prev) => ({ ...prev, [vegId]: selectedLabel }));
    if (selectedRate) {
      setSelectedPrice((prev) => ({ ...prev, [vegId]: selectedRate.value }));
    }
  };

  const handleAddToCart = (veg) => {
    const quantity = selectedQuantity[veg.id] || "1 Kg";
    const price = selectedPrice[veg.id] || veg.veg_rate_1;

    if (!userEmail) {
      alert("Please ensure phone number is provided.");
      return;
    }

    // 🕒 Get current time in IST (Indian Standard Time)
    // Get IST time
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istTime = new Date(utc + 5.5 * 60 * 60000);

    // Format to "DD-MM-YYYY HH:mm"
    const pad = (n) => (n < 10 ? "0" + n : n);
    const added_date = `${pad(istTime.getDate())}-${pad(
      istTime.getMonth() + 1
    )}-${istTime.getFullYear()} ${pad(istTime.getHours())}:${pad(
      istTime.getMinutes()
    )}`;
    console.log("here is the date", added_date);

    const cartItem = {
      shop_name: shopDetails.shop_name,
      shop_id: shopId,
      phonenumber: userEmail,
      veg_name: veg.veg_name,
      veg_image_name: veg.veg_image_name,
      veg_quantity: quantity,
      veg_rate: price,
      veg_des1: veg.veg_des,
      added_date: added_date, // ⬅️ Send this to backend
    };
    console.log(veg.veg_des);
    //track event script
    if (typeof window.gtag === "function") {
      window.gtag("event", "add_to_cart", {
        veg_name: veg.veg_name,
        veg_id: veg.id,
        quantity_label: quantity,
        price: price,
        phone: userEmail,
        user_id: userEmail,
        shop_id: shopId,
        shop_name: shopDetails.shop_name,
      });
    }

    addToCart(cartItem, quantity, price);

    fetch("https://yaasaai.com/myphpapi/addtocartdebug.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartItem),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Item added to cart successfully") {
          setShowToast(true);
          setTimeout(() => setShowToast(false), 1000);

          if (onCartUpdate) onCartUpdate();
        } else {
          // 👇 Backend ka exact message alert karega
          alert(data.message || "Failed to add item to cart");
        }
      })
      .catch(() => alert("Failed to add item to cart"));
  };

  const toggleCart = () => setIsCartOpen(!isCartOpen);

  // Filter using both English and Hindi search terms
  const filteredVegetables = vegetables.filter((veg) => {
    const vegEng = veg?.veg_name?.toLowerCase?.() || "";
    const vegHin = veg?.veg_name_hindi?.toLowerCase?.() || "";
    const termEng = searchedVegEng?.toLowerCase?.() || "";
    const termHin = searchedVegHin?.toLowerCase?.() || "";

    return (
      vegEng.includes(termEng) ||
      vegHin.includes(termEng) ||
      vegEng.includes(termHin) ||
      vegHin.includes(termHin)
    );
  });

  // Sort exact match first
  const sortedVegetables = filteredVegetables.sort((a, b) => {
    const termEng = searchedVegEng?.toLowerCase?.() || "";
    const termHin = searchedVegHin?.toLowerCase?.() || "";

    const aMatch =
      a?.veg_name?.toLowerCase() === termEng ||
      a?.veg_name_hindi?.toLowerCase() === termEng ||
      a?.veg_name?.toLowerCase() === termHin ||
      a?.veg_name_hindi?.toLowerCase() === termHin;

    const bMatch =
      b?.veg_name?.toLowerCase() === termEng ||
      b?.veg_name_hindi?.toLowerCase() === termEng ||
      b?.veg_name?.toLowerCase() === termHin ||
      b?.veg_name_hindi?.toLowerCase() === termHin;

    if (aMatch && !bMatch) return -1;
    if (!aMatch && bMatch) return 1;
    return 0;
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <Container fluid style={{ paddingTop: "80px" }} className="px-4">
      {/* Toast popup */}
      {showToast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#28a745",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            zIndex: 1050,
            fontWeight: "600",
            fontSize: "0.9rem",
            pointerEvents: "none",
          }}
        >
          Item added to cart!
        </div>
      )}

      <Row className="justify-content-center mt-2">
        <Col md={10}>
          <div className="shop-profile-card p-1 shadow-lg rounded bg-white d-flex align-items-center">
            <div className="shop-image-container">
              {shopDetails ? (
                <Image
                  src={`https://yaasaai.com/ShopImages/${shopDetails.shop_image}`}
                  className="shop-image rounded"
                  alt={shopDetails.shop_name}
                  title={shopDetails.shop_name}
                />
              ) : (
                <p>Loading image...</p>
              )}
            </div>
            <div className="shop-details ms-1">
              {shopDetails && (
                <>
                  <h5 className="fw-bold text-success">
                    {shopDetails.shop_name}
                  </h5>
                  <h6>{shopDetails.shop_address}</h6>
                  {/*  <button
                    className="btn btn-primary btn-sm mt-2"
                    onClick={() => setShowVideo(true)}
                  >
                    Watch
                  </button> */}
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {(searchedVegEng || searchedVegHin) && (
            <div className="searched-veg-display mb-3 p-2 bg-light rounded">
              <strong>You searched for:</strong> {searchedVegEng}{" "}
              {searchedVegHin && `(${searchedVegHin})`}
            </div>
          )}

          <h5 className="h2head">
            {isShopClosed
              ? "This shop is currently closed."
              : "All Vegetables Available at this Shop"}
          </h5>

          {!isShopClosed && (
            <div className="d-flex flex-wrap gap-3 veg-card-container">
              {!isShopClosed && sortedVegetables.length > 0 ? (
                sortedVegetables.map((veg) => {
                  const lowerName = veg.veg_name?.toLowerCase();
                  const isKgType = veg.qty_type === "kg";

                  // For KG-type products
                  const kgRates = [
                    { label: "5 Kg", value: veg.veg_rate_5 },
                    { label: "2 Kg", value: veg.veg_rate_2 },
                    { label: "1 Kg", value: veg.veg_rate_1 },
                    { label: "500 gm", value: veg.veg_rate_500 },
                    { label: "250 gm", value: veg.veg_rate_250 },
                    { label: "100 gm", value: veg.veg_rate_100 },
                  ].filter((rate) => rate.value);

                  // For PC-type products
                  const pcRates = [
                    { label: "1 pc", value: veg.veg_rate_1 },
                    { label: "2 pcs", value: veg.veg_rate_1 * 2 },
                    { label: "3 pcs", value: veg.veg_rate_1 * 3 },
                  ].filter((rate) => rate.value);

                  // For Kiwi only: show "pkt"
                  const kiwiPktRates = [
                    { label: "1 pkt", value: veg.veg_rate_1 },
                    { label: "2 pkts", value: veg.veg_rate_1 * 2 },
                    { label: "3 pkts", value: veg.veg_rate_1 * 3 },
                  ];

                  // Choose correct displayRates
                  const displayRates =
                    lowerName === "kiwi"
                      ? kiwiPktRates
                      : isKgType
                      ? kgRates
                      : pcRates;

                  return (
                    <div
                      key={veg.id}
                      className="card p-2 text-center"
                      style={{
                        width: "100px",
                        fontSize: "0.65rem", // smaller text
                        borderRadius: "10px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        className="veg-image img-fluid rounded"
                        src={`https://yaasaai.com/vegetableimages/${veg.veg_image_name}`}
                        alt={veg.veg_name}
                        title={veg.veg_name_hindi}
                        style={{
                          height: "80px",
                          objectFit: "cover",
                          marginBottom: "5px",
                        }}
                      />

                      <div className="card-body p-1">
                        <p
                          className="mb-1 fw-semibold"
                          style={{
                            fontSize: "0.6rem",
                            textTransform: "capitalize",
                            color: "green",
                          }}
                        >
                          {veg.veg_name}
                          {/* <br />
      <span className="text-muted" style={{ fontSize: "0.6rem" }}>
        ( {veg.veg_name_hindi} )
      </span>*/}
                        </p>
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "0.6rem",
                            color: "coral",
                            fontWeight: "bold",
                          }}
                        >
                          {veg.veg_des ? veg.veg_des : <br />}
                        </p>
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "0.6rem",
                            color: "coral",
                            fontWeight: "bold",
                          }}
                        >
                          ₹ {veg.veg_rate_1} /{" "}
                          {["kiwi", "coconut water"].includes(
                            veg.veg_name?.toLowerCase()
                          )
                            ? veg.veg_name.toLowerCase() === "kiwi"
                              ? "pkt"
                              : "pcs"
                            : "Kg"}
                        </p>

                        <div>
                          <label
                            className="form-label fw-bold text-success"
                            style={{ fontSize: "0.5rem", color: "green" }}
                          >
                            🔽 Select Quantity
                          </label>

                          <select
                            className="form-select mb-1 animate__animated animate__pulse"
                            style={{
                              fontSize: "0.7rem",
                              border: "2px solid #ff9800", // orange highlight
                              fontWeight: "600",
                              backgroundColor: "#fff3e0", // light orange background
                              color: "#333",
                              boxShadow: "0 0 6px rgba(255, 152, 0, 0.5)",
                              transition: "all 0.3s ease",
                            }}
                            value={selectedQuantity[veg.id] || ""}
                            onChange={(e) =>
                              handleQuantityChange(e, veg.id, displayRates)
                            }
                            onFocus={(e) =>
                              (e.target.style.borderColor = "#f44336")
                            } // red on focus
                            onBlur={(e) =>
                              (e.target.style.borderColor = "#ff9800")
                            }
                          >
                            <option value="" disabled>
                              🛒
                            </option>
                            {displayRates.map((rate, index) => (
                              <option key={index} value={rate.label}>
                                ✅ {rate.label} - ₹{rate.value}
                              </option>
                            ))}
                          </select>

                          <button
                            className="btn btn-sm btn-success w-100"
                            style={{ fontSize: "0.7rem" }}
                            onClick={() => handleAddToCart(veg)}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No vegetables available at this shop.</p>
              )}
            </div>
          )}
        </Col>
      </Row>

      {isCartOpen && <Cart cart={cartData} onClose={toggleCart} />}

      <div className="mt-4">
        <ShopCard />
        <FruitShopCard />

        {/* show video component  */}
      </div>
      {showVideo && shopDetails?.video_filename && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 2000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setShowVideo(false)}
        >
          <div
            style={{ position: "relative", width: "90%", maxWidth: "720px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <video
              controls
              autoPlay
              style={{ width: "100%", borderRadius: "10px" }}
            >
              <source
                src={`https://yaasaai.com/videos/${shopDetails.video_filename}`}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <button
              className="btn btn-danger"
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                borderRadius: "50%",
              }}
              onClick={() => setShowVideo(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </Container>
  );
};

export default ShopProfile;
